
import { useState } from 'react';

interface HeroFAQProps {
  onSearch: (query: string) => void;
}

const HeroFAQ = ({ onSearch }: HeroFAQProps) => {
  const [query, setQuery] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
    onSearch(e.target.value);
  };

  return (
    <section className="relative h-80 flex items-end pb-14 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/78100bf14941d8039458a8635b183f65.jpg"
          alt="Madeira, Portugal"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/45 to-black/65"></div>
      </div>
      <div className="relative w-full max-w-3xl mx-auto px-6 text-center">
        <p className="text-white/70 text-xs uppercase tracking-widest mb-2 font-medium">
          Tudo o que precisa de saber
        </p>
        <h1
          className="text-4xl md:text-5xl font-bold text-white mb-6"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Perguntas Frequentes
        </h1>
        <div className="relative">
          <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 text-lg"></i>
          <input
            type="text"
            value={query}
            onChange={handleChange}
            placeholder="Pesquise uma pergunta..."
            className="w-full pl-11 pr-5 py-4 rounded-full bg-white text-slate-700 text-sm placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-white/50 shadow-xl"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroFAQ;
